import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { Subscription } from "rxjs";
import { BrandService, BrandHomeService } from "@app/api/api";
import { environment } from "environments/environment";
import { Router } from "@angular/router";
import { UtilService } from "@app/services/util.service";
@Component({
	selector: "meu-app-home-page-logo-partner",
	templateUrl: "./app-home-page-logo-partner.component.html",
	styleUrls: ["./app-home-page-logo-partner.component.scss"],
})
export class AppHomePageLogoPartnerComponent implements OnInit {
	private subscriptions: Subscription[] = [];
	brand = [];
	constructor(
		private brandService: BrandService,
		private cd: ChangeDetectorRef,
		private brandHomeService: BrandHomeService,
		private router: Router
	) {}
	logoPartner1: any = [
		{ name: "toyota.png", hover: false },
		{ name: "logo-rexroth.png", hover: false },
		{ name: "Kalmar-Ottawa-min.png", hover: false },
		{ name: "LOGO-RAYMOND.png", hover: false },
		{ name: "logo-sun-hydraulic.png", hover: false },
		{ name: "total-source.png", hover: false },
		{ name: "KALMAR-LOGO.png", hover: false },
		{ name: "combilift.png", hover: false },
	];
	logoPartner2: any = [
		{ name: "yale-logo.png", hover: false },
		{ name: "volvopenta.png", hover: false },
		{ name: "LOGO-APP.png", hover: false },
		{ name: "logo-danfoss.png", hover: false },
		{ name: "logo-dana.png", hover: false },
		{ name: "Konecranes.png", hover: false },
		{ name: "Logo-rema.png", hover: false },
		{ name: "BT_forklift.png", hover: false },
	];
	path: any = "/assets/media/logo-partner/grayscale/";
	backend = environment.backendhost;
	ngOnInit() {
		this.logoPartner1.forEach((item) => {
			item = this.path + item;
		});
		this.logoPartner2.forEach((item) => {
			item = this.path + item;
		});
		this.getBrand();
	}
	ngOnDestroy() {
		this.subscriptions.forEach((sb) => sb.unsubscribe());
	}
	mouseEvent(item) {
		switch (item.hover) {
			// case true:
			//   return '/assets/media/logo-partner/logo-color/' + item.logo;
			// case false:
			//   return '/assets/media/logo-partner/grayscale/' + item.logo;
			// default:
			//   return '/assets/media/logo-partner/grayscale/' + item.logo;

			case true:
				return this.backend + item.extend_brand.logo;
			case false:
				return this.backend + item.extend_brand.logo;
			default:
				return this.backend + item.extend_brand.logo;
		}
	}
	getBrand() {
		this.subscriptions.push(
			this.brandHomeService.apiBrandHomesGet().subscribe((res) => {
				this.brand = res.data.collection;
				this.cd.detectChanges();
			})
		);
	}

	getProductByBrand(item) {
		this.router.navigate(["/searchbybrand"], {
			queryParams: {
				brandId: item.extend_brand.id,
				brandName: UtilService.slugify(item.extend_brand.name),
			},
		});
	}
}
